export const DEFAULT_MAP_PIN = {
  lat: 62.45349854740122,
  lng: -114.37367180162714,
};

export const aadRedirectUri = `${process.env.REACT_APP_STAFF_AUTH_LINK}?response_type=code&redirect_uri=${window.location.origin}${process.env.REACT_APP_STAFF_LOGIN_REDIRECT}&client_id=${process.env.REACT_APP_STAFF_AUTH_CLIENTID}`;

export const shareReviewDialogMessage =
  'You can share the link below with others so they can view your draft. Users who have this link will also be able to make edits (if they are logged in and a member of your organization).';
export const shareCommentDialogMessage = 'You can share the link below with others so they can view your draft.';

export const autoSavingInterval = parseInt(process.env.REACT_APP_AUTOSAVING_INTERVAL || '120000', 10);

export const CUSTOM_TOPIC = 'CUSTOM';

export const TABLE_ROWS_PER_PAGE = 25;

export const queryParams = [
  'take',
  'skip',
  'orderBy',
  'order',
  'organizationId',
  'type',
  'status',
  'dateRange',
  'currentPage',
];
